import { useEffect, useState } from "react";
import { AI_CHANGED, aiStatus, type AiStatus } from "../../api/ai";

/** Whether AI is on here and which parts, for the nav, the top bar and Settings. null while loading; `{ available: false }` when off. */
export function useAiStatus(): AiStatus | null {
  const [status, setStatus] = useState<AiStatus | null>(null);
  useEffect(() => {
    let live = true;
    const load = () => void aiStatus().then((s) => live && setStatus(s));
    load();
    window.addEventListener(AI_CHANGED, load);
    return () => {
      live = false;
      window.removeEventListener(AI_CHANGED, load);
    };
  }, []);
  return status;
}
